import { PropsWithChildren } from 'react';

import { graphql } from 'gatsby';

import {
  StrapiStageImage as StageImageComponent,
  StageImageProps,
} from '../../../components/strapi/stage-image';
import { PossibleStageComponents } from './stage-section';

export const StageImageFragment = graphql`
  fragment StageImageFragment on STRAPI__COMPONENT_SHARED_STAGE_IMAGE {
    strapi_component
    headline
    subline
    image {
      ...StrapiImageFragment
    }
  }
`;

export const componentName = 'shared.stage-image';

export type StageImageData = StageImageProps['data'] & {
  strapi_component: typeof componentName;
};

export const isStageImage = (
  component: PossibleStageComponents,
): component is StageImageData => {
  return component.strapi_component === componentName;
};

export const StrapiStageImage = ({
  data,
  children,
}: PropsWithChildren<{ data: StageImageData }>) => (
  <StageImageComponent data={data}>{children}</StageImageComponent>
);
